import apiCall from 'apps/investment/apiCalls/user-ekyc-records';
import { DetailPage } from 'common/ui/admin-CRUD/page';
import { Navigate, useParams } from 'react-router-dom';
import ItemDetail from './detail';

// The record list now sits at the bottom of the user's identification page.
// That page swaps 'current' for the user's identification id.
export const UserEkycRecordsRedirect = () => {
  const { userId } = useParams();
  return (
    <Navigate
      to={`/investment/users/${userId}/identifications/current`}
      replace
    />
  );
};

export const UserEkycRecordsDetailPage = () => {
  const { userId } = useParams();

  return (
    <DetailPage
      title="EKYC Record"
      apiCall={apiCall}
      listUrl={`/investment/users/${userId}/user-ekyc-records`}
      ItemDetail={ItemDetail}
      options={{ editEnabled: false }}
    />
  );
};
